<!-- 车场通道信息变更上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "cmd": "reportParkChange ",
          "parkCode": "",
		  "timeoutAfterPayment": "",
		  "updateTime": "",
		  "chargePicChangeFlag": "",
 
        },
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报车场信息变更到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportParkChange",
          precondition: "无",
          fitSystem: "云停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',tdName: 'info1'},
			  {tableHead: '是否必填',tdName: 'info2'}
			  , {tableHead: '类型',tdName: 'info3'}
			  ,{tableHead: '说明',tdName: 'info4'
            }],
            td: [
				{
				info1: 'parkCode',info2: '是',info3: 'String',info4: '停车场编号'
				},
              {
                info1: 'timeoutAfterPayment',info2: '是',info3: 'Integer',info4: '缴费后免费离场时间(单位分钟)'
				},
              {
                info1: 'updateTime',info2: '是',info3: 'Integer',info4: '更新时间(yyyyMMddHHmmss)'
				},
              {
                info1: 'chargePicChangeFlag',info2: '是',info3: 'Integer',info4: '停车场收费规则图片是否更改标志。'
              }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportParkChange.vue